<template>
  <validation-observer
    v-if="stepData.propertySort === 'A'"
    v-slot="propertyFloorObserver"
    key="floor"
    slim
  >
    <form-section
      id="property-floor"
      v-bind="propertyFloorObserver"
      :validated="formObserver.validated"
    >
      <form-row
        label="Floor number?"
      >
        <validation-provider
          v-slot="{ failed, failedRules }"
          name="Property Floor"
          :vid="`${stepId}_property-floor`"
          rules="required"
          slim
        >
          <radio
            v-model="questionData.propertyFloor"
            name="property-floor"
            column
            wide
            :error="failed"
            :data-test="snakeCase(questionFields.propertyFloor)"
            :error-messages="getFieldErrors('propertyFloor', failedRules)"
            :items="propertyFloorItems"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from '@/components/questions/Base.vue';

export default {
  name: 'question-property-floor',
  extends: QuestionBase,
  data () {
    return {
      fields: ['propertyFloor'],
    };
  },
  computed: {
    propertyFloorItems () {
      return this.helpers.createOptions({ source: this.constants.HOME_PROPERTY_FLOOR });
    },
  },
};
</script>
